import React from "react";
import { Helmet } from "react-helmet-async";
import seoData from "../../assets/data/seo.json";

const Disclaimer = () => {
  const seo = seoData["disclaimer"] || {};
  const { title, description, keywords, canonical } = seo;

  return (
    <div className="bg-white min-h-screen">
      <Helmet>
        <title>{title}</title>
        <meta name="description" content={description} />
        {keywords && <meta name="keywords" content={keywords} />}
        {canonical && <link rel="canonical" href={canonical} />}
      </Helmet>

      <section className="py-20 bg-gray-50 border-b border-gray-100">
        <div className="container mx-auto px-6 text-center">
          <h1 className="font-bold text-gray-900 uppercase tracking-tight text-[28px] md:text-[50px] lg:text-[72px]">Disclaimer</h1>
          <p className="mt-4 text-gray-500 max-w-2xl mx-auto font-medium text-[12px] md:text-[14px] lg:text-[16px]">Important notices and limitations</p>
        </div>
      </section>

      <section className="py-20 container mx-auto px-6 max-w-4xl">
        <div className="prose prose-red max-w-none text-gray-600 space-y-8 font-medium">
          <div>
            <h2 className="font-bold text-gray-900 mb-4 uppercase text-[26px] md:text-[48px]">1. Listing Information</h2>
            <p>The information provided on jettyestates.com regarding properties, listing status, pricing, dimensions, boundaries, and descriptions is compiled from sources deemed reliable, but is not guaranteed. Buyers are advised to independently verify all property specifications prior to purchase or lease agreements.</p>
          </div>

          <div>
            <h2 className="font-bold text-gray-900 mb-4 uppercase text-[26px] md:text-[48px]">2. Artistic Renderings and Visuals</h2>
            <p>Any computer-generated renderings, walkthroughs, photos, plans, or drawings featured on our website are conceptual, artistic representations intended to show general aesthetic character only. The final finishes, landscaping, and final layouts may vary significantly from these illustrations.</p>
          </div>

          <div>
            <h2 className="font-bold text-gray-900 mb-4 uppercase text-[26px] md:text-[48px]">3. Third-Party Links</h2>
            <p>This website may contain links to external sites managed by affiliate developers, contractors, or financial partners. We do not control, endorse, or assume responsibility for the accuracy or practices of these external websites.</p>
          </div>

          <div>
            <h2 className="font-bold text-gray-900 mb-4 uppercase text-[26px] md:text-[48px]">4. Financial and Legal Advice</h2>
            <p>The contents of this site do not constitute financial, investment, legal, or tax advice. Property acquisition carries inherent risks, and potential clients should seek counsel from qualified real estate brokers, legal practitioners, and financial experts before entering into contracts.</p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Disclaimer;
